import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import ReportDetailPage from '../pages/ReportDetailPage/ReportDetailPage'
import PrivateRoute from './PrivateRoute'
import HomePage from '../pages/HomePage/HomePage'
import OverviewPage from '../pages/OverviewPage/OverviewPage'
import AccessControlPage from '../pages/AccessControlPage/AccessControlPage'
import WizardPage from '../pages/WizardPage/WizardPage'
import { SignInRedirectCallback } from '../auth/components/signInRedirectCallback'
import { Logout } from '../auth/components/logout'
import { LogoutCallback } from '../auth/components/logoutCallback'
import { SigninSilentCallback } from '../auth/components/signinSilentCallback'
import { SignInRedirect } from '../auth/components/signinRedirect'
import { NotFound } from '@pages/WizardPage/components/NotFound'

export const AppRoutes = () => (
  <Routes>
    <Route
      path="/signin-oidc-callback"
      element={<SignInRedirectCallback />}
    />
    <Route
      path="/signin"
      element={<SignInRedirect />}
    />
    <Route
      path="/logout"
      element={<Logout />}
    />
    <Route
      path="/logout/callback"
      element={<LogoutCallback />}
    />
    <Route
      path="/silentrenew"
      element={<SigninSilentCallback />}
    />
    <Route
      path="/"
      element={
        <PrivateRoute returnUrl="/">
          <HomePage />
        </PrivateRoute>
      }
    />
    <Route
      path="/reports/:reportId"
      element={
        <PrivateRoute returnUrl="/reports">
          <ReportDetailPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/overview"
      element={
        <PrivateRoute returnUrl="/overview">
          <OverviewPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/access"
      element={
        <PrivateRoute returnUrl="/access">
          <AccessControlPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/create-report/:step"
      element={
        <PrivateRoute returnUrl=":step">
          <WizardPage />
        </PrivateRoute>
      }></Route>
    <Route
      path="*"
      element={<NotFound />}
    />
  </Routes>
)

AppRoutes.displayName = 'AppRoutes'
